<template>
  <div class="flex items-center bg-white gap-4">
    <h3 class="text-lg font-bold">Share this:</h3>
    <ul class="flex gap-2">
      <li v-for="site in sites">
        <NuxtLink
          :to="site.link"
          :style="'color: ' + site.color + ';'"
          :title="'Share on ' + site.site"
          target="_blank"
        >
          <div class="w-8" v-html="site.icon" />
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<script setup>
const props = defineProps({ molecule: Object });

const sites = [
  {
    site: "Twitter",
    link:
      "https://twitter.com/intent/tweet?text=" +
      encodeURIComponent(props.molecule.title + ": " + props.molecule.shareUrl),
    title: props.molecule.title,
    color: "#1da1f2",
    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z"/></svg>',
  },
  {
    site: "Facebook",
    link:
      "https://www.facebook.com/sharer/sharer.php?u=" +
      encodeURIComponent(props.molecule.shareUrl),
    title: props.molecule.title,
    color: "#1877f2",
    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor"><path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"/></svg>',
  },
  {
    site: "Pinterest",
    link:
      "https://pinterest.com/pin/create/button/?url=" +
      encodeURIComponent(props.molecule.shareUrl) +
      "&media=" +
      encodeURIComponent(props.molecule.imgSrc),
    title: props.molecule.title,
    color: "#bd081c",
    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor"><path d="M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"/></svg>',
  },
];
</script>
